import withParams from "@src/components/widgets/HOC/withParams";
import React from "react";
import { WidgetTemplateComponentType } from "@src/interface/Widget";
import { ILandingStandardWidgetMenuParams } from "../interface";
import useBackboneContext from "@src/backbone/provider/useBackboneContext";
import MenuMargauxMotin from "design-system/src/Components/WidgetPart/LandingMenu/MenuMargauxMotin/MenuMargauxMotin";

const MenuMargauxMotinTemplate: WidgetTemplateComponentType =
  withParams<ILandingStandardWidgetMenuParams>((props) => {
    const { p } = props;
    const { app } = useBackboneContext();

    return (
      <MenuMargauxMotin
        title={p("title")}
        subtitle={p("subtitle")}
        linkText={p("link_text")}
        onClick={() => app.go("listing")}
      />
    );
  });

export default MenuMargauxMotinTemplate;
